export default __webpack_public_path__ + "static/media/metalfloor.3ea69be0.png";